import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import { CartContext } from "../../context/CartContext";
import { API_BASE } from "../../utils/api";
import { validatePassword } from "../../utils/validatePassword";
import { fetchSalesman } from "../../utils/fetchSalesman";
import { FiEye, FiEyeOff } from "react-icons/fi";
import ReCAPTCHA from "react-google-recaptcha";
import { getMyAccountId } from "../../utils/config";
import { Link } from "react-router-dom";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [message, setMessage] = useState(null);
  const { clearCart } = useContext(CartContext);
  const history = useHistory();
  const { login } = useContext(UserContext);
  const MYACCOUNT_ID = getMyAccountId();

  const [pendingUserData, setPendingUserData] = useState(null);

  const [showChangePassword, setShowChangePassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [showRecoverForm, setShowRecoverForm] = useState(false);
  const [recoverUsername, setRecoverUsername] = useState("");
  const [recoverEmail, setRecoverEmail] = useState("");

  const [showCodeVerification, setShowCodeVerification] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const [captchaToken, setCaptchaToken] = useState(null);
  const [isRecoveryFlow, setIsRecoveryFlow] = useState(false);

  useEffect(() => {
    const savedUser = localStorage.getItem("remember_user");
    if (savedUser) {
      setUsername(savedUser);
      setRemember(true);
    }
  }, []);

  const showMessage = (text, type = "error") => {
    setMessage({ text, type });
    setTimeout(() => setMessage(null), 5000);
  };

  const clearNavigationState = (userData = null) => {
    const sessionKeys = [
      "frequent_products_page",
      "frequent_products_scroll",
      "last_category_page",
      "last_category_id",
      "last_selected_group",
      "last_has_prod_freq",
      "product_list_scroll",
      "last_section",
      "force_home",
    ];
    sessionKeys.forEach((k) => sessionStorage.removeItem(k));

    const localKeys = ["checkout_payload", "proforma_source"];
    if (userData?.changeCustomer) {
      localKeys.push("order_express_items");
    }
    localKeys.forEach((k) => localStorage.removeItem(k));
  };

  const handleLogin = async () => {
    if (!username || !password) {
      showMessage("Ingrese usuario y contraseña");
      return;
    }

    try {
      const encodedPassword = encodeURIComponent(password);
      const response = await fetch(
        `${API_BASE}/api-ultra/api/ws/login_euser?user=${username}&password=${encodedPassword}`
      );

      if (!response.ok) {
        showMessage("Usuario o contraseña incorrectos");
        return;
      }


      const data = await response.json();

      if (data.myaccountId !== MYACCOUNT_ID) {
        showMessage("Usuario no pertenece a esta cuenta");
        return;
      }

      if (data.discontinued) {
        showMessage("Su usuario aún no esta habilitado");
        return;
      }

      localStorage.setItem("user_myaccount_id", data.myaccountId);
      localStorage.setItem("last_activity", Date.now().toString());

      if (remember) {
        localStorage.setItem("remember_user", username);
      } else {
        localStorage.removeItem("remember_user");
      }

      const params = await fetchParameters(data.idEmployee);
      const fullData = { ...params, token: data.token };

      const salesman = await fetchSalesman(fullData.idSalesman);
      localStorage.setItem("salesman", JSON.stringify(salesman));
      window.dispatchEvent(new CustomEvent("salesman-updated"));

      if (password === "Ultra123*") {
        setPendingUserData(fullData);
        setShowChangePassword(true);
        return;
      }

      clearNavigationState(fullData);
      login(fullData);
      history.push("/dashboard");

    } catch (error) {
      console.error("Error en login:", error);
      showMessage("Error conectando al servidor");
    }
  };

  const handleRecoverPassword = async () => {
    if (!recoverUsername || !recoverEmail) {
      showMessage("Ingrese su usuario y correo electrónico");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(recoverEmail)) {
      showMessage("Ingrese un correo electrónico válido");
      return;
    }
    if (!captchaToken) {
      showMessage("Complete la verificación de seguridad");
      return;
    }

    try {
      const res = await fetch(
        `${API_BASE}/api-ultra/api/ws/recuperar_password?user=${encodeURIComponent(recoverUsername)}&email=${encodeURIComponent(recoverEmail)}`
      );

      if (!res.ok) {
        showMessage("Error conectando al servidor");
        return;
      }

      const found = await res.json();

      if (!found) {
        showMessage("Usuario o correo no encontrado");
        return;
      }

      setPendingUserData(found);
      setIsRecoveryFlow(true);
      setShowRecoverForm(false);
      setShowCodeVerification(true);
      setCaptchaToken(null);
    } catch (error) {
      console.error("Error en recuperar contraseña:", error);
      showMessage("Error conectando al servidor");
    }
  };

  const handleValidateCode = async () => {
    if (!verificationCode || verificationCode.length !== 6) {
      showMessage("Ingrese el código de 6 dígitos");
      return;
    }

    try {
      const res = await fetch(
        `${API_BASE}/api-ultra/api/ws/validar_codigo?codigo=${encodeURIComponent(verificationCode)}`
      );

      if (!res.ok) {
        showMessage("Error conectando al servidor");
        return;
      }

      const valid = await res.json();

      if (!valid) {
        showMessage("Código de verificación no válido o expirado");
        return;
      }

      setShowCodeVerification(false);
      setVerificationCode("");
      setShowChangePassword(true);
    } catch (error) {
      console.error("Error al validar código:", error);
      showMessage("Error conectando al servidor");
    }
  };

  const handleChangePassword = async () => {
    if (!newPassword || !confirmPassword) {
      showMessage("Ingrese y confirme la nueva contraseña");
      return;
    }
    if (newPassword === "Ultra123*") {
      showMessage("La nueva contraseña no puede ser la contraseña temporal");
      return;
    }
    const { valid, message } = validatePassword(newPassword);
    if (!valid) {
      showMessage(message);
      return;
    }
    if (newPassword !== confirmPassword) {
      showMessage("Las contraseñas no coinciden");
      return;
    }

    try {
      const formData = new URLSearchParams();
      formData.append("id_employee", pendingUserData.idEmployee);
      formData.append("password", newPassword);

      const res = await fetch(`${API_BASE}/api-ultra/api/ws/update_employee`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      });

      if (!res.ok) {
        showMessage("Error al actualizar la contraseña");
        return;
      }

      setShowChangePassword(false);

      if (isRecoveryFlow) {
        setIsRecoveryFlow(false);
        setPendingUserData(null);
        setNewPassword("");
        setConfirmPassword("");
        showMessage("Contraseña actualizada. Inicie sesión con su nueva contraseña.", "success");
        return;
      }

      const data = pendingUserData;

      clearNavigationState(data);
      login(data);
      history.push("/dashboard");
    } catch (error) {
      console.error("Error al cambiar contraseña:", error);
      showMessage("Error conectando al servidor");
    }
  };

  const fetchParameters = async (idEmployee) => {
    const res = await fetch(
      `${API_BASE}/api-ultra/api/ws/parameters_e_user?id_employee=${idEmployee}`
    );
    if (!res.ok) throw new Error("No se pudo obtener los parámetros del usuario");
    return res.json();
  };


  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center px-4 sm:px-6 md:px-8 overflow-hidden">

      {/* 🔥 Imagen optimizada sin tocar nada más */}
      <img
        src="https://www.ultra-erp.pro/logos/image-login.png"
        alt="Login background"
        className="absolute inset-0 w-full h-full object-cover"
        loading="eager"
        fetchPriority="high"
        decoding="async"
      />

      <div className="relative z-10 w-full max-w-md">

        <div className="bg-gray-50 p-8 rounded-lg shadow-sm border border-gray-200">

          <div onKeyDown={handleKeyPress}>

            {!showChangePassword && !showRecoverForm && !showCodeVerification && (
              <>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Usuario"
                  className="w-full px-4 py-3 mb-5 border border-gray-300 rounded focus:outline-none focus:border-2 focus:border-brand-primary focus:ring-0 bg-white"
                />

                <div className="relative mb-5">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Contraseña"
                    className="w-full px-4 py-3 pr-10 border border-gray-300 rounded focus:outline-none focus:border-2 focus:border-brand-primary focus:ring-0 bg-white"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  >
                    {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                  </button>
                </div>
              </>
            )}

            {!showChangePassword && !showRecoverForm && !showCodeVerification && (
              <>
                <div className="flex items-center mb-6">
                  <button
                    onClick={() => setRemember(!remember)}
                    className={`w-10 h-5 flex items-center rounded-full p-1 transition ${remember ? "bg-brand-primary" : "bg-gray-300"}`}
                  >
                    <div
                      className={`bg-white w-4 h-4 rounded-full shadow transform transition ${remember ? "translate-x-5" : "translate-x-0"}`}
                    />
                  </button>

                  <span className="ml-3 text-gray-700 text-sm">
                    Recordar mi usuario
                  </span>
                </div>

                <button
                  onClick={handleLogin}
                  className="w-full px-6 py-3 bg-brand-primary text-white rounded font-semibold flex items-center justify-center gap-2 hover:brightness-90 transition text-lg mb-6"
                >
                  <span className="text-lg">🔒</span>Iniciar sesión
                </button>

                <div className="mb-6">
                  <button
                    type="button"
                    onClick={() => setShowRecoverForm(true)}
                    className="text-sm underline text-gray-600 hover:text-gray-900"
                  >
                    Recuperar contraseña
                  </button>
                </div>
              </>
            )}

            {showRecoverForm && (
              <div className="mt-2">
                <p className="text-sx font-semibold text-center mb-4 text-gray-700">
                  ¿Desea recuperar su contraseña?
                </p>
                <input
                  type="text"
                  value={recoverUsername}
                  onChange={(e) => setRecoverUsername(e.target.value)}
                  placeholder="Usuario"
                  autoComplete="off"
                  className="w-full px-4 py-3 mb-3 border border-gray-300 rounded focus:outline-none focus:border-2 focus:border-brand-primary focus:ring-0 bg-white"
                />
                <input
                  type="email"
                  value={recoverEmail}
                  onChange={(e) => setRecoverEmail(e.target.value)}
                  placeholder="Correo electrónico"
                  autoComplete="off"
                  className="w-full px-4 py-3 mb-4 border border-gray-300 rounded focus:outline-none focus:border-2 focus:border-brand-primary focus:ring-0 bg-white"
                />
                <div className="mb-4 flex justify-center">
                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                    onChange={(token) => setCaptchaToken(token)}
                    onExpired={() => setCaptchaToken(null)}
                    hl="es"
                  />
                </div>
                <button
                  onClick={handleRecoverPassword}
                  className="w-full bg-brand-primary text-white py-3 rounded font-semibold hover:brightness-90 transition mb-3"
                >
                  Buscar cuenta
                </button>
                <button
                  type="button"
                  onClick={() => { setShowRecoverForm(false); setRecoverUsername(""); setRecoverEmail(""); }}
                  className="w-full text-sm text-gray-500 hover:text-gray-700 underline"
                >
                  Volver al inicio de sesión
                </button>
              </div>
            )}

            {showCodeVerification && (
              <div className="mt-2">
                <p className="text-sx font-semibold text-center mb-3 text-gray-700">
                  Código de Verificación
                </p>
                <p className="text-sm text-gray-600 mb-4 text-justify leading-relaxed">
                  Se ha enviado un código de 6 dígitos al correo  
                  <span className="font-semibold"> {recoverEmail}</span>. Ingrese el código para reestablecer la contraseña.
                </p>
                <input
                  type="text"
                  value={verificationCode}
                  onChange={(e) => setVerificationCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
                  placeholder="Código de verificación"
                  autoComplete="off"
                  maxLength={6}
                  className="w-full px-4 py-3 mb-4 border border-gray-300 rounded focus:outline-none focus:border-2 focus:border-brand-primary focus:ring-0 bg-white tracking-widest text-center text-lg"
                />
                <button
                  onClick={handleValidateCode}
                  className="w-full bg-brand-primary text-white py-3 rounded font-semibold hover:brightness-90 transition mb-3"
                >
                  Validar Código
                </button>
                <button
                  type="button"
                  onClick={() => { setShowCodeVerification(false); setVerificationCode(""); setRecoverUsername(""); setRecoverEmail(""); }}
                  className="w-full text-sm text-gray-500 hover:text-gray-700 underline"
                >
                  Volver al inicio de sesión
                </button>
              </div>
            )}

            {showChangePassword && (
              <div className="mt-6 border-t pt-4">
                <p className="text-sm font-semibold text-center mb-4 text-gray-700">
                  Reestrablecer contraseña
                </p>
                <div className="relative mb-3">
                  <input
                    type={showNewPassword ? "text" : "password"}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    placeholder="Nueva contraseña"
                    autoComplete="new-password"
                    className="w-full px-4 py-3 pr-10 border border-gray-300 rounded focus:outline-none focus:border-2 focus:border-brand-primary focus:ring-0 bg-white"
                  />
                  <button
                    type="button"
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  >
                    {showNewPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                  </button>
                </div>
                <div className="relative mb-4">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Confirmar nueva contraseña"
                    autoComplete="new-password"
                    className="w-full px-4 py-3 pr-10 border border-gray-300 rounded focus:outline-none focus:border-2 focus:border-brand-primary focus:ring-0 bg-white"
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  >
                    {showConfirmPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                  </button>
                </div>
                <p className="text-sm text-gray-800 mb-4">
                  Debe tener mínimo 8 caracteres, incluyendo mayúscula, minúscula, dígito numérico y caracter especial.
                </p>
                <button
                  onClick={handleChangePassword}
                  className="w-full bg-brand-primary text-white py-3 rounded font-semibold hover:brightness-90 transition"
                >
                  Guardar y continuar
                </button>
              </div>
            )}


            {message && (
              <div
                className={`mt-4 py-3 px-5 text-center rounded ${message.type === "error"
                  ? "bg-red-200 text-red-700"
                  : "bg-green-200 text-green-700"
                  }`}
              >
                {message.text}
              </div>
            )}

          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-gray-100 mb-4">
            ¿Primera vez? Cree su cuenta para realizar ordenes.
          </p>

          <Link
            to="/register"
            className="inline-block border border-gray-600 px-6 py-3 rounded font-semibold flex items-center justify-center gap-3 hover:bg-gray-100 transition"
          >
            ➕ Crear una cuenta
          </Link>
        </div>

      </div>
    </div>
  );
}